var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20.594,
    viewBox: "0 0 20.613 20.594",
    width: 20.613,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#59c974",
    transform: "translate(-64 -64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.753 68.753-1.941 6.337h-9.921l-1.743-6.337h13.6m-14.986-4.753h-3.762v1.584h2.594l.455 1.584 2.475 8.951a.746.746 0 0 0 .178.3l-1.287 2.059a.779.779 0 0 0 -.257.574.794.794 0 0 0 .792.792h14.06v-1.586h-12.594l.99-1.584h10.02a.778.778 0 0 0 .733-.554l2.416-7.881a.811.811 0 0 0 -.733-1.069h-15.169l-.455-1.584z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 769.584a1.584 1.584 0 1 0 1.584-1.584 1.584 1.584 0 0 0 -1.584 1.584z",
    transform: "translate(-187.247 -686.574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m704 769.584a1.584 1.584 0 1 0 1.584-1.584 1.584 1.584 0 0 0 -1.584 1.584z",
    transform: "translate(-624.158 -686.574)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.4bb99c96210d3c1d0a179429c29b82ae.svg";
export { ForwardRef as ReactComponent };